function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatetimepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a86a010d-b306-483d-a76d-8a8d571a3299",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f9dd3ba7-1a78-415c-8d00-39f53c7bdcb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.5-.31a1.47,1.47,0,0,0-1.56-1.5q-1.19,0-2.37,0c-.38,0-.55.17-.57.55V-.4c0,.41.19.58.6.59h1.87c0,.09,0,.14,0,.19,0,1.25,0,2.49,0,3.74a2.76,2.76,0,0,1-.21,1.07,16.4,16.4,0,0,1-1.22,2.16,2.46,2.46,0,0,1-4.15-.06l-.46-.69a4.63,4.63,0,0,1-.93-2.47c0-1.29,0-2.58,0-3.87,0,0,0,0,0-.06h1.88c.39,0,.56-.18.57-.56s0-.59,0-.88-.17-.56-.58-.56H-53.9A1.5,1.5,0,0,0-55.5-.23c0,1.1,0,2.21,0,3.32a10.69,10.69,0,0,0,.1,1.26,10.59,10.59,0,0,0,2,4.6c.55.79,1.16,1.54,1.74,2.32a2.55,2.55,0,0,1,.63,1.5c0,1.05,0,2.1,0,3.15a4,4,0,0,1-2.58,3.57,5.92,5.92,0,0,1-2.25.26A4,4,0,0,1-60,15.63c0-1.09,0-2.18,0-3.27a.31.31,0,0,1,.24-.35,3.49,3.49,0,0,0,2.26-3.4,3.5,3.5,0,0,0-4.84-3.12A3.53,3.53,0,0,0-64,10.58a3.53,3.53,0,0,0,2,1.52c0,.86,0,1.72,0,2.58a14.07,14.07,0,0,0,.08,1.95,5.8,5.8,0,0,0,3.27,4.5,7.42,7.42,0,0,0,5.3.37,5.84,5.84,0,0,0,4.24-5c.1-.94,0-1.9.07-2.85,0-.65.1-1.3.17-2a.89.89,0,0,1,.39-.66c.46-.37.92-.74,1.35-1.14a7.67,7.67,0,0,0,2.51-5c.15-1.72.12-3.45.12-5.17M-60.88,10.91A1.84,1.84,0,0,1-62.68,9a1.83,1.83,0,0,1,1.86-1.75A1.83,1.83,0,0,1-59,9.13a1.83,1.83,0,0,1-1.83,1.78",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b138740c-7514-43d6-bcc4-c0ba1e5a87fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93,3H11.1A.94.94,0,0,0,12,2a.94.94,0,0,0-.92-1H7.94A.93.93,0,0,0,7,2a1,1,0,0,0,.93,1",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a308ceba-a3a2-4c8c-910f-f1d2dfa87c30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -604,
    y: -197,
    width: 1528,
    height: 1064,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b592540f-e101-4f0b-af82-99a490f488d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.12a.91.91,0,0,0,.94.88A1,1,0,0,0,14,3.16c0-.77,0-1.55,0-2.33A.91.91,0,0,0,13,0a.94.94,0,0,0-1,.88V3.12",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b64efed2-1ea0-48f7-b3be-72ea7d5de13b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4b95974-fbbc-4e14-8757-c06bbccebc84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: -1,
    width: 4,
    height: 6,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb479f79-02a7-411f-8f89-d75fe2a58938"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,4a.93.93,0,0,0,1-.87V.88A.92.92,0,0,0,5.06,0,1,1,0,0,0,4,.82Q4,2,4,3.19A.93.93,0,0,0,5,4",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6d1cf1a-9ac8-477a-be93-02882377790b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 3,
    height: 4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a663e25a-e42b-416f-bb2e-e7a56ceed039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.88,13.06a5.65,5.65,0,0,0-1.81-3.2A.5.5,0,0,1,18,9.54c0-1.49,0-3,0-4.49,0-.62,0-1.25,0-1.87A2.22,2.22,0,0,0,16,1a10.61,10.61,0,0,0-1.26,0,.86.86,0,1,0,0,1.71c.32,0,.64,0,1,0a.5.5,0,0,1,.52.48c0,.55,0,1.11,0,1.67H1.68V3.37a.59.59,0,0,1,.64-.66h.82A.87.87,0,0,0,4,1.94.84.84,0,0,0,3.29,1a6,6,0,0,0-1.58.05A2.24,2.24,0,0,0,0,3.37v11.5A2.37,2.37,0,0,0,1.07,17a2.62,2.62,0,0,0,1.45.35H9.3a.36.36,0,0,1,.33.15,5.52,5.52,0,0,0,5,2.54,5.33,5.33,0,0,0,3.74-1.69,5.7,5.7,0,0,0,1.55-5.25M8.78,15.6H2.37c-.47,0-.68-.2-.68-.68,0-2.72,0-5.45,0-8.17a.69.69,0,0,1,0-.13H16.25V8.73A5.52,5.52,0,0,0,10.54,9.9a5.84,5.84,0,0,0-1.76,5.7m5.52,2.69a4.09,4.09,0,1,1,4-4.06,4.05,4.05,0,0,1-4,4.06",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc7479ae-8c26-4175-9ebe-152208ff6c55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.64,14a.57.57,0,0,1-.14-.42c0-.56,0-1.11,0-1.66s-.38-.93-.76-.9A.9.9,0,0,0,14,12V13c0,.34,0,.69,0,1a1.27,1.27,0,0,0,.28.86c.47.59.94,1.18,1.42,1.76a.66.66,0,0,0,1.08,0,1.14,1.14,0,0,0,0-1.4L15.64,14",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b138740c-7514-43d6-bcc4-c0ba1e5a87fd)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a308ceba-a3a2-4c8c-910f-f1d2dfa87c30)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 7,
    height: 4,
    style: {
      fill: "#516983"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b592540f-e101-4f0b-af82-99a490f488d4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a308ceba-a3a2-4c8c-910f-f1d2dfa87c30)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: -1,
    width: 4.01,
    height: 6.01,
    style: {
      fill: "#516983"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b64efed2-1ea0-48f7-b3be-72ea7d5de13b)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a4b95974-fbbc-4e14-8757-c06bbccebc84)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bb479f79-02a7-411f-8f89-d75fe2a58938)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a6d1cf1a-9ac8-477a-be93-02882377790b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: -1,
    width: 4,
    height: 6,
    style: {
      fill: "#516983"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a663e25a-e42b-416f-bb2e-e7a56ceed039)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a308ceba-a3a2-4c8c-910f-f1d2dfa87c30)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.03,
    width: 22,
    height: 21.03,
    style: {
      fill: "#516983"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#bc7479ae-8c26-4175-9ebe-152208ff6c55)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a308ceba-a3a2-4c8c-910f-f1d2dfa87c30)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.99,
    y: 9.97,
    width: 5.09,
    height: 8.13,
    style: {
      fill: "#516983"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetimepicker);
export default __webpack_public_path__ + "static/media/datetimepicker.4acd71c1a40732d52580d7a61b9f19e7.svg";
export { ForwardRef as ReactComponent };